import { render, staticRenderFns } from "./NewSectionForm.vue?vue&type=template&id=90098fb0&scoped=true&"
import script from "./NewSectionForm.vue?vue&type=script&lang=js&"
export * from "./NewSectionForm.vue?vue&type=script&lang=js&"
import style0 from "./NewSectionForm.vue?vue&type=style&index=0&id=90098fb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90098fb0",
  null
  
)

export default component.exports